import {Component, OnInit} from '@angular/core';
import {SmartTableConfigInterface} from '../../../../shared/interface';
import {MatDialog} from '@angular/material/dialog';

import {ActivatedRoute} from '@angular/router';
import {RealEstateAgentService} from '../../../../shared/service/real-estate-agent.service';
import {RealEstateAgentModel} from '../../../../shared/models/realEstateAgentModel';
import {RealEstateAgentsModel} from '../../../../shared/models/real-estate-agent-items.model';
import {RealEstateAgentModalComponent} from '../../../../shared/modal/real-estate-agent-modal/real-estate-agent-modal.component';

@Component({
  selector: 'app-real-estate-agent-manager',
  templateUrl: './real-estate-agent-manager.component.html',
  styleUrls: ['./real-estate-agent-manager.component.scss']
})
export class RealEstateAgentManagerComponent implements OnInit {

  tableData: RealEstateAgentsModel;
  selectedHomeCarouselItem: RealEstateAgentModel;
  smartTableConfig: SmartTableConfigInterface;


  constructor(public dialog: MatDialog, private realEstateAgentService: RealEstateAgentService, private activatedRoute: ActivatedRoute) {

    this.initSmartTable();
    this.realEstateAgentService.realEstateAgentItems.subscribe((realEstateAgentItems: RealEstateAgentsModel) => {
      this.tableData = realEstateAgentItems;
    });

    this.realEstateAgentService.selectedRealEstateAgentItem.subscribe((partnerItem: RealEstateAgentModel) => {
      this.selectedHomeCarouselItem = partnerItem;
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(
      (data: { realEstateAgentItemsResolver: any }) => {
        this.tableData.items = data.realEstateAgentItemsResolver;
      }
    );
  }

  initSmartTable() {
    this.smartTableConfig = {
      columns: [
        {labelKey: 'REAL_ESTATE_AGENT.ADMIN.TAB.1', dataKey: 'imageUrl', isImage: true},
        {labelKey: 'REAL_ESTATE_AGENT.ADMIN.NAME', dataKey: 'name'},
        {labelKey: 'REAL_ESTATE_AGENT.ADMIN.TITLE', dataKey: 'title'},
        {labelKey: 'REAL_ESTATE_AGENT.ADMIN.PHONE', dataKey: 'phone'},
        {labelKey: 'REAL_ESTATE_AGENT.ADMIN.EMAIL', dataKey: 'email'},
      ],
      displayedColumns: ['imageUrl', 'name', 'title', 'phone', 'email']
    };
  }


  openDialog(selectedRealEstateAgentModel?: RealEstateAgentModel) {

    this.dialog.open(RealEstateAgentModalComponent, {
      hasBackdrop: true,
      width: '60vw',
      data: selectedRealEstateAgentModel ? selectedRealEstateAgentModel : new RealEstateAgentModel()
    });

  }


  deleteItem(event) {
    this.realEstateAgentService.deleteRealEstateAgentItem(event.item, event.dialogRef);
  }

}
